import * as React from 'react';
import { ClientInterface } from './shared';
import  { Form, Modal, Icon } from 'semantic-ui-react';
import LocationInput from 'src/components/inputs/LocationInput';
import ContactInfoInput from 'src/components/inputs/ContactInfoInput';

import './ClientEdit.scss';
import Client from 'src/stores/application/classes/Client';

interface ClientEditProps {
    fromObject: Partial<ClientInterface>;
    resolveRow: (client?: ClientInterface) => any;
    rejectRow: (err?: Error | { isNormal: boolean, typedId: number }) => any;
    isNew?: boolean;
}

export default class ClientEdit extends React.Component<
    ClientEditProps, 
    ClientInterface & {[key: string]: any}
> {
    resolveRow?: (client?: ClientInterface) => any;
    rejectRow?: (err?: any) => any;
    
    constructor(props: ClientEditProps) {
        super(props);
        const { resolveRow, rejectRow, fromObject } = props;

        this.resolveRow = resolveRow;
        this.rejectRow = rejectRow;
        
        this.state = {
            clientId: fromObject.clientId,
            typedId: fromObject.typedId,
                        
            name: fromObject.name,
            icon: fromObject.icon,
            brief: fromObject.brief,

            location: fromObject.location,
            contacts: fromObject.contacts || []
        };
    }

    render() {
        const changeHandler = this.handleChange.bind(this);
        const submitHandler = this.handleSubmit.bind(this);
        const { name, brief }  = this.state;
        return(
            <Modal 
                closeIcon
                size="fullscreen"
                open={true}
                onClose={this.handleClose.bind(this)}
                className="standard-padding center-margin tb-margin"
                style={{
                    marginTop: 10, 
                    marginLeft: 'auto', 
                    marginRight: 'auto',
                    padding: '21px',
                    boxSizing: 'content-box',
                    overflowY: 'scroll'
                }}
                dimmer="inverted"
                closeOnDimmerClick={true}
            >
                <Modal.Header>Editing Client {this.state.name}</Modal.Header>
                    <Modal.Content>
                        <Form onSubmit={submitHandler} >

                        <Modal.Description className="top-margin">
                            <Form.Field id="name">
                                <label>Name</label>
                                <Form.Input 
                                    placeholder="Name" 
                                    name="name" 
                                    defaultValue={name} 
                                    onChange={changeHandler} 
                                />
                            </Form.Field>

                            <Form.Field id="brief">
                                <label>Brief on Client</label>
                                <Form.TextArea
                                    placeholder="Brief" 
                                    name="brief"
                                    defaultValue={brief} 
                                    onChange={changeHandler} 
                                />
                            </Form.Field>

                            <Form.Field id="location">
                                <label>Location Input</label>
                                <LocationInput 
                                    name="location"
                                    {...  
                                        (
                                            this.props.fromObject.location
                                            && this.props.fromObject.location.lat
                                            && typeof this.props.fromObject.location.lng
                                        ) ?
                                        this.props.fromObject.location
                                        : {}  
                                    }
                                    onLocationChange={changeHandler}
                                />
                            </Form.Field>
                                    
                            <Form.Field id="contact">
                                <label>Contact Information:</label>
                                <ContactInfoInput
                                    name="contacts"
                                    onChange={changeHandler}
                                    initialValue={this.props.fromObject.contacts || []}
                                />
                            </Form.Field>
                        </Modal.Description>
                    <Modal.Actions>
                        <Form.Button primary float="right" className="top-margin">
                            Submit <Icon name="chevron right"/>
                        </Form.Button>
                    </Modal.Actions>
                    </Form>
                </Modal.Content>
            </Modal>
        );
    }

    handleChange(
        e: any, 
        { 
            name, value 
        }: {
            name: string, 
            value: any
        }
    ) {
        this.setState({ [name]: value });
    }

    handleSubmit = (event: any) => {
        if (event.keyCode !== 13) {
            this.resolveRow(new Client(this.state));
        }
    }

    handleClose = () => {
        this.rejectRow({ isNormal: true, typedId: this.state.typedId});
    }
}


// WEBPACK FOOTER //
// ./src/container/Client/ClientEdit.tsx